export default __webpack_public_path__ + "static/media/website.126dca9d.svg";